module.exports = __webpack_public_path__ + "img/scan.6d255f6f.png";